<script>
  export let course
  export let mod;
</script>

<div class="mt-10 text-center">
  <h3 class="text uppercase">{course.name}</h3>
  <h2 class="text-3xl uppercase">{mod.name}</h2>
</div>